
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-action-figure-generator",
      function () {
        return require("private-next-pages/ai-action-figure-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-action-figure-generator"])
      });
    }
  